"use client";

import React from "react";
import {
    Area,
    AreaChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
    Line
} from "recharts";

const data = [
    { date: "7.7", ideal: 13.5, actual: 13.8 },
    { date: "8.7", ideal: 12.5, actual: 13.2 },
    { date: "9.7", ideal: 11.5, actual: 12.8 },
    { date: "11.7", ideal: 10.5, actual: 12.0 },
    { date: "12.7", ideal: 9.5, actual: 12.0 },
    { date: "13.7", ideal: 8.5, actual: 12.5 },
    { date: "14.7", ideal: 7.5, actual: 13.1 }, // Peak
    { date: "15.7", ideal: 6.5, actual: 11.5 },
    { date: "16.7", ideal: 5.5, actual: 9.0 },
    { date: "17.7", ideal: 4.5, actual: 8.5 },
    { date: "18.7", ideal: 3.5, actual: 8.0 },
    { date: "19.7", ideal: 2.5, actual: 8.0 },
    { date: "20.7", ideal: 1.5, actual: 7.0 }, // End high
];

export function SprintBurndown() {
    return (
        <div className="w-full h-[400px] border rounded-xl p-4 bg-background shadow-sm">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart
                    data={data}
                    margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="hsl(var(--muted-foreground))" opacity={0.2} />
                    <XAxis
                        dataKey="date"
                        tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis
                        hide
                        domain={[0, 15]}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "hsl(var(--card))",
                            borderColor: "hsl(var(--border))",
                            borderRadius: "0.5rem",
                            fontSize: "12px"
                        }}
                    />

                    {/* Ideal Line (Grey) */}
                    <Line
                        type="monotone"
                        dataKey="ideal"
                        stroke="hsl(var(--muted-foreground))"
                        strokeWidth={2}
                        dot={false}
                        activeDot={false}
                        opacity={0.5}
                    />

                    {/* Actual Area (Blue) */}
                    <Area
                        type="monotone"
                        dataKey="actual"
                        stroke="#0ea5e9"
                        fill="#0ea5e9"
                        fillOpacity={1}
                        strokeWidth={0}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}
